import moment from 'moment';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { formatDate, formatDateTime, formatNumberWithCommas } from '../../utils';

const RecruitmentStatus = ({
    dataRecruit,
    handleJumpUp,
    handleResetViewCount,
    handleExpired,
    handleClone,
    handleCloneReady,
    handleDelete,
    handleOption,
    className = '',
}) => {
    const [expandedItems, setExpandedItems] = useState(false);

    const statusMapping = {
        K: { text: '보관', bg: '#009e96' },
        O: { text: '게재중', bg: '#eb6100' },
        C: { text: '기간마감', bg: '#a0a0a0' },
        E: { text: '기간마감', bg: '#a0a0a0' },
        D: { text: '삭제', bg: '#6b738c' },
        P: { text: '입금대기', bg: '#2178aa' },
        V: { text: '승인대기', bg: '#c79b01' },
        W: { text: '등록대기', bg: '#336633' },
        X: { text: '미결제삭제', bg: '#6b738c' },
        J: { text: '승인거절', bg: '#6b738c' },
        N: { text: '입금기한만료', bg: '#6b738c' }
    };

    const handleShowMore = (seq) => {
        setExpandedItems((prev) => ({
            ...prev,
            [seq]: !prev[seq],
        }));
    };

    const getStatusText = (status) => {
        return statusMapping[status]?.text || '';
    };

    const getStatusBg = (status) => {
        return statusMapping[status]?.bg || '';
    };

    const getGoodNameText = (goodNameCode) => {
        switch (goodNameCode) {
            case '011':
                return '비즈니스 배너';
            case '0112':
                return '비즈니스 배너';
            case '002':
                return '그랜드 배너 (채용소식 포함)';
            case '0022':
                return '그랜드 배너 (채용소식 포함)';
            case '0023':
                return '그랜드 배너 (채용광고 디자인 서비스 포함)';
            case '003':
                return '프리미엄 배너 (채용소식 포함)';
            case '0032':
                return '프리미엄 배너 (채용소식 포함)';
            case '0033':
                return '프리미엄 배너 (채용광고 디자인 서비스 포함)';
            case '010':
                return '기업 배너';
            case '0102':
                return '기업 배너';
            case '008':
                return '핫리쿠르트 배너 (채용소식 포함)';
            case '0082':
                return '핫리쿠르트 배너 (채용소식 포함)';
            case '001':
                return '채용정보';
            case '7000':
                return '고정옵션 (프리미엄 배너)';
            case '6000':
                return '고정옵션 (그랜드 배너)';
            case '4000':
                return '고정옵션 (핫리쿠르트 배너)';
            case '5000':
                return '고정옵션 (채용정보)';
            case '1000':
                return '하이라이트 강조 1주';
            case '1500':
                return '하이라이트 강조 2주';
            case '2000':
                return '컬러 강조 1주';
            case '2500':
                return '컬러 강조 2주';
            case '3010':
                return '아이콘 강조 1주 (주목)';
            case '3020':
                return '아이콘 강조 1주 (HOT)';
            case '3510':
                return '아이콘 강조 2주 (주목)';
            case '3520':
                return '아이콘 강조 2주 (HOT)';
            default:
                return '';
        }
    };

    const getCardNameByCode = (code) => {
        const CARD_CODE_MAP = {
            '01': '하나카드',
            '02': '우리카드',
            '03': '롯데카드',
            '04': '현대카드',
            '06': '국민카드',
            11: '비씨카드',
            12: '삼성카드',
            14: '신한카드(구.LG카드 포함)',
            21: '글로벌 VISA',
            22: '글로벌 MASTER',
            23: '글로벌 JCB',
            24: '글로벌 아멕스',
            25: '글로벌 다이너스',
            26: '중국은련카드',
            32: '광주카드',
            33: '전북카드',
            34: '하나SK카드',
            35: '산업카드',
            38: '우리BC카드 (44 사용 시 변경필요)',
            41: 'NH카드',
            43: '씨티카드',
            48: '신협체크카드',
            51: '수협카드',
            52: '제주카드',
            54: 'MG새마을금고체크',
            55: '케이뱅크카드',
            56: '카카오뱅크',
            71: '우체국체크',
            95: '저축은행체크',
        };

        return CARD_CODE_MAP[code] || '알 수 없는 카드';
    };

    return (
        <div className={`dntInf__table ${className}`}>
            <ul className="dntInf__grid dntInf__head">
                <li style={{ width: '150px' }}>
                    <div className="dntInf__stt-info">
                        등록일/상태
                        <img src="./images/icons/icon-info-th.png" alt="icon-step" />
                        <div className="tlt">
                            <div className="tlt__tit">채용소식 FLOW</div>
                            <div className="tlt__step">
                                <div className="tlt__step-item">
                                    <div className="tlt__step-top">
                                        STEP <span>01</span>
                                    </div>
                                    <div className="tlt__step-name">입금대기</div>
                                </div>
                                <img src="./images/PAJAC010/icon-step-arrow.png" alt="icon-step" />
                                <div className="tlt__step-item">
                                    <div className="tlt__step-top">
                                        STEP <span>02</span>
                                    </div>
                                    <div className="tlt__step-name">승인대기</div>
                                </div>
                                <img src="./images/PAJAC010/icon-step-arrow.png" alt="icon-step" />
                                <div className="tlt__step-item">
                                    <div className="tlt__step-top">
                                        STEP <span>03</span>
                                    </div>
                                    <div className="tlt__step-name">게재중</div>
                                </div>
                                <img src="./images/PAJAC010/icon-step-arrow.png" alt="icon-step" />
                                <div className="tlt__step-item">
                                    <div className="tlt__step-top">
                                        STEP <span>04</span>
                                    </div>
                                    <div className="tlt__step-name">기간마감</div>
                                </div>
                            </div>
                            <ul className="tlt__list">
                                <li className="tlt__item">
                                    <div className="tlt__item-lf">입금대기</div>
                                    <span className="tlt__item-rt">
                                        채용소식 내용은 등록하였지만 결제가 되지 않은 상태(채용소식 미등록된 상태)
                                    </span>
                                </li>
                                <li className="tlt__item">
                                    <div className="tlt__item-lf">승인대기</div>
                                    <span className="tlt__item-rt">
                                        채용소식은 결제는 되었지만, 덴탈잡 관리자가 공고 미승인 상태(채용공고 미등록된
                                        상태)
                                    </span>
                                </li>
                                <li className="tlt__item">
                                    <div className="tlt__item-lf">게재중</div>
                                    <span className="tlt__item-rt">채용소식이 덴탈잡 홈페이지에 등록된 상태</span>
                                </li>
                                <li className="tlt__item">
                                    <div className="tlt__item-lf">기간마감</div>
                                    <span className="tlt__item-rt">채용소식 서비스 일자가 마감되어 완료된 상태</span>
                                </li>
                                <li className="tlt__item">
                                    <div className="tlt__item-lf">채용마감</div>
                                    <span className="tlt__item-rt">
                                        서비스일자 중간에 회원님께서 채용소식을 강제 마감한 상태
                                    </span>
                                </li>
                                <li className="tlt__item">
                                    <div className="tlt__item-lf">등록대기</div>
                                    <span className="tlt__item-rt">
                                        채용소식 결제가 완료되었고 덴탈잡 승인도 완료되었으며, 서비스 일자가 아직
                                        아니어서 채용소식은 미등록된 상태
                                    </span>
                                </li>
                            </ul>
                            <svg
                                className="tlt__svg"
                                width={28}
                                height={16}
                                xmlns="http://www.w3.org/2000/svg"
                                version="1.1"
                            >
                                <polyline
                                    points="18 16 0 8 18 0"
                                    strokeWidth={1}
                                    stroke="#88abda"
                                    fill="#e6effa"
                                    paintOrder="fill"
                                />
                                <rect x={18} y={0} width={10} height={16} fill="#e6effa" />
                            </svg>
                        </div>
                    </div>
                </li>
                <li style={{ width: '344px' }}>채용공고</li>
                <li>지원자</li>
                <li>조회수</li>
                <li>관리</li>
            </ul>
            {dataRecruit && dataRecruit?.length > 0 ? (
                dataRecruit?.map((item, index) => {
                    return (
                        <div className="dntInf__item" key={'dataRecruit' + index}>
                            <ul className="dntInf__grid dtnInf__body bg-white">
                                <li className="d-flex flex-column" style={{ width: '150px' }}>
                                    <div style={{ marginBottom: '8px' }}>{formatDate(item?.addDate)}</div>
                                    <div
                                        style={{
                                            borderColor: getStatusBg(item.statusFlag),
                                            color: getStatusBg(item.statusFlag),
                                        }}
                                        className="dntInf__cnd"
                                        dangerouslySetInnerHTML={{ __html: getStatusText(item.statusFlag) }}
                                    ></div>
                                    <div style={{ position: 'relative', marginTop: '8px' }}>
                                        {item.statusFlag !== 'E' &&
                                            item.statusFlag !== 'C' &&
                                            item.statusFlag !== 'K' &&
                                            item.statusFlag !== 'W' &&
                                            item.statusFlag !== 'P' &&
                                            item.statusFlag !== 'N' && (
                                                <>
                                                    <button
                                                        type="button"
                                                        className="dntInf__jump"
                                                        onClick={() => handleJumpUp(item.seq)}
                                                    >
                                                        Jump up
                                                    </button>
                                                    <div className="tlt tlt--jump">
                                                        <div className="tlt__jump">
                                                            <span>Jump Up 버튼을 클릭</span>하시면 뒤로 밀렸던 회원님의
                                                            채용정보 내용이
                                                        </div>
                                                        <ul className="tlt__list2">
                                                            <li className="tlt__item2">
                                                                1)'고정옵션-채용정보'상품을 이용중이시라면
                                                                [채용정보]메뉴의 1페이지에서
                                                                <br />
                                                                &nbsp;&nbsp;맨 첫번째 줄로 이동합니다.
                                                            </li>
                                                            <li className="tlt__item2">
                                                                그렇지 않다면 [채용정보] 메뉴의 2페이지에서 맨 첫번째
                                                                줄로 이동합니다.
                                                            </li>
                                                        </ul>
                                                        <div className="tlt__jump">
                                                            <span>덴탈잡 모바일 앱</span>에서도 Jump Up이 가능하며,
                                                            하루에 여러 번 Jump Up을 하시면
                                                            <br />
                                                            회원님의 채용정보가 구직자에게 노출될 확률이 높습니다!
                                                        </div>
                                                        <svg
                                                            className="tlt__svg"
                                                            width={28}
                                                            height={16}
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            version="1.1"
                                                        >
                                                            <polyline
                                                                points="18 16 0 8 18 0"
                                                                strokeWidth={1}
                                                                stroke="#88abda"
                                                                fill="#e6effa"
                                                                paintOrder="fill"
                                                            />
                                                            <rect x={18} y={0} width={10} height={16} fill="#e6effa" />
                                                        </svg>
                                                    </div>
                                                </>
                                            )}
                                    </div>
                                </li>
                                <li style={{ width: '344px' }}>
                                    <div className="dntInf__dl">
                                        <div className="dntInf__dt title-recruitment" style={{ overflow: 'unset' }}>
                                            <div
                                                className="twoLine-text"
                                                onClick={(e) => {
                                                    const newWindow = window.open(
                                                        `/pajac050-${item?.seq}?flag=${item?.statusFlag}`,
                                                        '_blank',
                                                        'width=1200,height=1000',
                                                    );
                                                    if (!newWindow) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            >
                                                {item.title}
                                            </div>
                                        </div>
                                        <div className="dntInf__dd">
                                            {/* {item.statusFlag === 'O' && (
                                                <span>
                                                    {currentDay.isBetween(item.recruitFrom, item.recruitEnd)
                                                        ? '채용중'
                                                        : currentDay.isBefore(item.recruitEnd)
                                                            ? '마감'
                                                            : ''}
                                                </span>
                                            )}
                                            {(item.statusFlag === 'C' || item.statusFlag === 'E') && (
                                                <span>채용마감</span>
                                            )}{' '} */}
                                            {formatDate(item.recruitFrom)} ~ {formatDate(item.recruitEnd)}
                                        </div>
                                        <div className="dntInf__dd">모집직종 : {item.recruitClass}</div>
                                        <div className="dntInf__dd">모집인원 : {item.recruitNum}명</div>
                                        <div className="dntInf__dd">직급 : {item.recruitPosition}</div>
                                        <div className="dntInf__dd">최종 수정: {formatDateTime(item.modDate)}</div>
                                    </div>
                                </li>
                                {/* <li style={{ width: '100px' }}>
                                    {item.statusFlag !== 'E' && item.statusFlag !== 'C' && item.statusFlag !== 'K' && (
                                        <button
                                            type="button"
                                            className="dntInf__jump"
                                            onClick={() => handleJumpUp(item.seq)}
                                        >
                                            Jump UP
                                        </button>
                                    )}
                                </li> */}
                                {item.statusFlag === 'K' ? (
                                    <li></li>
                                ) : (
                                    <li>
                                        <div className="dntInf__aplc">
                                            <span className="bold">{item.applicantCount}</span>
                                            <span className="dntInf__reset">미열람 {item.unread}</span>
                                        </div>
                                    </li>
                                )}

                                <li>
                                    <div className="dntInf__view">
                                        {item.visitedCnt}
                                        <button
                                            type="button"
                                            className="dntInf__reset"
                                            onClick={() => handleResetViewCount(item.seq)}
                                        >
                                            초기화
                                        </button>
                                    </div>
                                </li>
                                <li>
                                    <div className="dntInf__mng">
                                        {(item.statusFlag === 'C' || item.statusFlag === 'E') && (
                                            <Link
                                                to={`/pajac020-${item.seq}?step=1&flag=true`}
                                                className="dntInf__mng-btn blue"
                                            >
                                                기간연장/복사
                                            </Link>
                                        )}
                                        {item.statusFlag !== 'E' &&
                                            item.statusFlag !== 'C' &&
                                            item.statusFlag !== 'K' && (
                                                <>
                                                    <Link
                                                        to={`/pajac020-${item.seq}?update=true`}
                                                        className="dntInf__mng-btn blue"
                                                    >
                                                        수정
                                                    </Link>
                                                    <button
                                                        type="button"
                                                        className="dntInf__mng-btn"
                                                        onClick={() => handleClone(item.seq)}
                                                    >
                                                        복사
                                                    </button>

                                                    {item.statusFlag !== 'P' && (
                                                        <>
                                                            <button
                                                                type="button"
                                                                className="dntInf__mng-btn styleButton"
                                                                onClick={() => handleOption(item?.type, item.seq)}
                                                            >
                                                                강조/옵션 추가
                                                            </button>
                                                        </>

                                                    )}

                                                    {(item.statusFlag === 'O' ||
                                                        item.statusFlag === 'P' ||
                                                        item.statusFlag === 'V' ||
                                                        item.statusFlag === 'W') && (
                                                            <button
                                                                type="button"
                                                                className="dntInf__mng-btn red"
                                                                onClick={() => handleExpired(item.seq)}
                                                            >
                                                                마감
                                                            </button>
                                                        )}
                                                </>
                                            )}

                                        {item.statusFlag === 'K' && (
                                            <Link to={`/pajac020-${item.seq}`} className="dntInf__mng-btn blue">
                                                결제/수정
                                            </Link>
                                        )}
                                        {(item.statusFlag === 'K' ||
                                            item.statusFlag === 'V' ||
                                            item.statusFlag === 'P' ||
                                            item.statusFlag === 'W') && (
                                                <button
                                                    type="button"
                                                    className="dntInf__mng-btn"
                                                    onClick={() => handleDelete(item.statusFlag, item.seq)}
                                                >
                                                    삭제
                                                </button>
                                            )}
                                        {item.statusFlag === 'K' && (
                                            <button
                                                type="button"
                                                className="dntInf__mng-btn"
                                                onClick={() => handleCloneReady(item.seq)}
                                            >
                                                복사
                                            </button>
                                        )}
                                    </div>
                                </li>
                            </ul>
                            {Array.isArray(item?.listPayment) && item.listPayment.length > 0 && (
                                <>
                                    {(item.statusFlag === 'O'
                                        ? expandedItems[item.seq] !== false
                                        : expandedItems[item.seq] === true
                                    ) &&
                                        item.listPayment.map((payment, index) => (
                                            <div className="rcp" key={'payment' + index}>
                                                <div className="rcp__block">
                                                    <div className="rcp__lf-wrap">
                                                        <div
                                                            className="rcp__lf"
                                                            style={{
                                                                borderColor:
                                                                    payment?.resultCode !== '00' &&
                                                                        (payment?.payMethod === 'VBank' || payment?.payMethod === 'VBANK')
                                                                        ? '#2178aa'
                                                                        : '',
                                                                color:
                                                                    payment?.resultCode !== '00' &&
                                                                        (payment?.payMethod === 'VBank' || payment?.payMethod === 'VBANK')
                                                                        ? '#2178aa'
                                                                        : '',
                                                            }}
                                                        >
                                                            {
                                                                payment?.resultCode === '00'
                                                                    ? '결제완료'
                                                                    : (
                                                                        payment?.resultCode !== '00' &&
                                                                        payment?.payMethod !== 'VBank' &&
                                                                        payment?.payMethod !== 'VBANK'
                                                                    )
                                                                        ? '결제오류'
                                                                        : (
                                                                            new Date().setHours(0, 0, 0, 0) <=
                                                                            new Date(
                                                                                `${payment?.vactDate?.substring(0, 4)}-${payment?.vactDate?.substring(4, 6)}-${payment?.vactDate?.substring(6, 8)}`
                                                                            ).setHours(0, 0, 0, 0)
                                                                        )
                                                                            ? '입금대기'
                                                                            : '입금기한만료'
                                                            }

                                                        </div>
                                                    </div>
                                                    <div className="rcp__rt">
                                                        {payment?.payMethod === 'VBank' || payment?.payMethod === 'VBANK' ? (
                                                            <ul className="rcp__list">
                                                                <li className="rcp__item">
                                                                    <span>
                                                                        결제일:{' '}
                                                                        {payment.applDate
                                                                            ? moment(
                                                                                payment.applDate,
                                                                                'YYYYMMDD',
                                                                            ).format('YY.MM.DD')
                                                                            : ''}
                                                                        {payment?.payMethod !== 'EMTICKET' &&
                                                                            payment?.crPrice > 0 &&
                                                                            payment?.tid !== '' && (
                                                                                <a
                                                                                    className="rcp__text"
                                                                                    href={`https://iniweb.inicis.com/DefaultWebApp/mall/cr/cm/mCmReceipt_head.jsp?noTid=${payment?.tid}&noMethod=1`}
                                                                                    rel="noreferrer nofollow"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        window.open(
                                                                                            `https://iniweb.inicis.com/DefaultWebApp/mall/cr/cm/mCmReceipt_head.jsp?noTid=${payment?.tid}&noMethod=1`,
                                                                                            '_blank',
                                                                                            'width=430,height=700',
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    [영수증출력]
                                                                                </a>
                                                                            )}
                                                                    </span>
                                                                </li>
                                                                <li className="rcp__item">
                                                                    <span className="d-flex">
                                                                        입금 정보: {payment?.vactBankCode}(
                                                                        {payment?.vactNum})
                                                                    </span>
                                                                </li>
                                                                <li className="rcp__item">
                                                                    <span>
                                                                        입금 금액:{' '}
                                                                        {formatNumberWithCommas(payment?.crPrice)}원
                                                                    </span>
                                                                </li>
                                                                {payment?.crPrice !== 0 && payment?.vactDate && (
                                                                    <li className="rcp__item">
                                                                        <span>
                                                                            입금 마감일:{' '}
                                                                            {payment?.vactDate
                                                                                ? moment(
                                                                                    payment?.vactDate,
                                                                                    'YYYYMMDD',
                                                                                ).format('YY.MM.DD')
                                                                                : ''}
                                                                        </span>
                                                                    </li>
                                                                )}
                                                                {payment?.resultCode !== '00' && (
                                                                    <li className="rcp__item">
                                                                        * 결제 완료 후 서비스 상품 및 기간 확인이
                                                                        가능합니다.
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        ) : payment?.payMethod === 'Card' || payment?.payMethod === 'CARD' || payment?.payMethod === 'VCard' ? (
                                                            <ul className="rcp__list">
                                                                <li className="rcp__item">
                                                                    <span>
                                                                        결제일:{' '}
                                                                        {payment.applDate
                                                                            ? moment(
                                                                                payment.applDate,
                                                                                'YYYYMMDD',
                                                                            ).format('YY.MM.DD')
                                                                            : ''}
                                                                        {payment?.payMethod !== 'EMTICKET' &&
                                                                            payment?.crPrice > 0 &&
                                                                            payment?.tid !== '' && (
                                                                                <a
                                                                                    className="rcp__text"
                                                                                    href={`https://iniweb.inicis.com/DefaultWebApp/mall/cr/cm/mCmReceipt_head.jsp?noTid=${payment?.tid}&noMethod=1`}
                                                                                    rel="noreferrer nofollow"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        window.open(
                                                                                            `https://iniweb.inicis.com/DefaultWebApp/mall/cr/cm/mCmReceipt_head.jsp?noTid=${payment?.tid}&noMethod=1`,
                                                                                            '_blank',
                                                                                            'width=430,height=700',
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    [영수증출력]
                                                                                </a>
                                                                            )}
                                                                    </span>
                                                                </li>
                                                                <li className="rcp__item">
                                                                    <span className="d-flex">
                                                                        카드 정보:{' '}
                                                                        {getCardNameByCode(payment?.cardCode)}(
                                                                        {payment?.cardNum})
                                                                    </span>
                                                                </li>
                                                                <li className="rcp__item">
                                                                    <span>
                                                                        결제 금액:{' '}
                                                                        {formatNumberWithCommas(payment?.crPrice)}원
                                                                    </span>
                                                                </li>
                                                                {payment?.crPrice !== 0 && payment?.vactDate && (
                                                                    <li className="rcp__item">
                                                                        <span>
                                                                            입금 마감일:{' '}
                                                                            {payment?.vactDate
                                                                                ? moment(
                                                                                    payment?.vactDate,
                                                                                    'YYYYMMDD',
                                                                                ).format('YY.MM.DD')
                                                                                : ''}
                                                                        </span>
                                                                    </li>
                                                                )}
                                                                {payment?.resultCode !== '00' && (
                                                                    <li className="rcp__item">
                                                                        * 결제 완료 후 서비스 상품 및 기간 확인이
                                                                        가능합니다.
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        ) : (
                                                            <ul className="rcp__list">
                                                                <li className="rcp__item">
                                                                    <span>
                                                                        결제일:{' '}
                                                                        {payment.applDate
                                                                            ? moment(
                                                                                payment.applDate,
                                                                                'YYYYMMDD',
                                                                            ).format('YY.MM.DD')
                                                                            : ''}
                                                                    </span>
                                                                </li>
                                                                <li className="rcp__item">
                                                                    <span>
                                                                        결제금액:{' '}
                                                                        <span style={{ whiteSpace: 'nowrap' }}>
                                                                            {formatNumberWithCommas(payment.crPrice)}원
                                                                        </span>
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        )}
                                                        <ul className="rcp__list">
                                                            {payment.goodNameCode
                                                                ?.split(',')
                                                                .some((code) =>
                                                                    [
                                                                        '011',
                                                                        '0112',
                                                                        '002',
                                                                        '0022',
                                                                        '0023',
                                                                        '003',
                                                                        '0032',
                                                                        '0033',
                                                                        '010',
                                                                        '0102',
                                                                        '008',
                                                                        '0082',
                                                                        '001',
                                                                    ].includes(code),
                                                                ) && (
                                                                    <li className="rcp__item">
                                                                        <span>
                                                                            메인상품:{' '}
                                                                            {payment.goodNameCode
                                                                                .split(',')
                                                                                .filter((code) =>
                                                                                    [
                                                                                        '011',
                                                                                        '0112',
                                                                                        '002',
                                                                                        '0022',
                                                                                        '0023',
                                                                                        '003',
                                                                                        '0032',
                                                                                        '0033',
                                                                                        '010',
                                                                                        '0102',
                                                                                        '008',
                                                                                        '0082',
                                                                                        '001',
                                                                                    ].includes(code),
                                                                                )
                                                                                .map((item) => (
                                                                                    <React.Fragment
                                                                                        key={'goodNameCode' + item}
                                                                                    >
                                                                                        {getGoodNameText(item)}
                                                                                        {item !== '001' && (
                                                                                            <div
                                                                                                style={{
                                                                                                    paddingLeft: '8px',
                                                                                                }}
                                                                                            >
                                                                                                (
                                                                                                {payment.bannerStartDate
                                                                                                    ? moment(
                                                                                                        payment.bannerStartDate,
                                                                                                    ).format('MM.DD')
                                                                                                    : ''}{' '}
                                                                                                ~{' '}
                                                                                                {payment.bannerEndDate
                                                                                                    ? moment(
                                                                                                        payment.bannerEndDate,
                                                                                                    ).format('MM.DD')
                                                                                                    : ''}
                                                                                                )
                                                                                            </div>
                                                                                        )}
                                                                                    </React.Fragment>
                                                                                ))}
                                                                        </span>
                                                                    </li>
                                                                )}

                                                            {payment.goodNameCode
                                                                ?.split(',')
                                                                .some((code) =>
                                                                    ['4000', '5000', '5002', '6000', '7000'].includes(
                                                                        code,
                                                                    ),
                                                                ) && (
                                                                    <li className="rcp__item">
                                                                        <span>
                                                                            고정상품:{' '}
                                                                            {payment.goodNameCode
                                                                                .split(',')
                                                                                .filter((code) =>
                                                                                    [
                                                                                        '4000',
                                                                                        '5000',
                                                                                        '5002',
                                                                                        '6000',
                                                                                        '7000',
                                                                                    ].includes(code),
                                                                                )
                                                                                .map((item) => (
                                                                                    <React.Fragment
                                                                                        key={'goodNameCode' + item}
                                                                                    >
                                                                                        {getGoodNameText(item)}
                                                                                        {payment?.optEndDate && (
                                                                                            <div
                                                                                                style={{
                                                                                                    paddingLeft: '8px',
                                                                                                }}
                                                                                            >
                                                                                                (
                                                                                                {moment(
                                                                                                    payment.optStartDate,
                                                                                                ).format('MM.DD')}{' '}
                                                                                                ~{' '}
                                                                                                {moment(
                                                                                                    payment.optEndDate,
                                                                                                ).format('MM.DD')}
                                                                                                )
                                                                                            </div>
                                                                                        )}
                                                                                    </React.Fragment>
                                                                                ))}
                                                                        </span>
                                                                    </li>
                                                                )}

                                                            {payment.goodNameCode
                                                                ?.split(',')
                                                                .some((code) =>
                                                                    [
                                                                        '1000',
                                                                        '1500',
                                                                        '2000',
                                                                        '2500',
                                                                        '3010',
                                                                        '3020',
                                                                        '3510',
                                                                        '3520',
                                                                    ].includes(code),
                                                                ) && (
                                                                    <li className="rcp__item">
                                                                        <span>강조상품: </span>
                                                                        <ul>
                                                                            {payment.goodNameCode
                                                                                .split(',')
                                                                                .filter((code) =>
                                                                                    [
                                                                                        '1000',
                                                                                        '1500',
                                                                                        '2000',
                                                                                        '2500',
                                                                                        '3010',
                                                                                        '3020',
                                                                                        '3510',
                                                                                        '3520',
                                                                                    ].includes(code),
                                                                                )
                                                                                .map((item) => (
                                                                                    <li key={'goodNameCode' + item}>
                                                                                        <div>
                                                                                            {getGoodNameText(item)}
                                                                                            {payment.extraStartDate &&
                                                                                                payment.extraEndDate && (
                                                                                                    <div>
                                                                                                        (
                                                                                                        {moment(
                                                                                                            payment.extraStartDate,
                                                                                                        ).format(
                                                                                                            'MM.DD',
                                                                                                        )}{' '}
                                                                                                        ~{' '}
                                                                                                        {moment(
                                                                                                            payment.extraEndDate,
                                                                                                        ).format('MM.DD')}
                                                                                                        )
                                                                                                    </div>
                                                                                                )}
                                                                                        </div>
                                                                                    </li>
                                                                                ))}
                                                                        </ul>
                                                                    </li>
                                                                )}
                                                        </ul>
                                                    </div>
                                                </div>
                                                {payment?.payMethod === 'EMTICKET' &&
                                                    payment?.type === '1' &&
                                                    payment?.couponNum !== '' &&
                                                    payment.goodNameCode
                                                        ?.split(',')
                                                        .some((code) =>
                                                            [
                                                                '011',
                                                                '0112',
                                                                '002',
                                                                '0022',
                                                                '0023',
                                                                '003',
                                                                '0032',
                                                                '0033',
                                                                '010',
                                                                '0102',
                                                                '008',
                                                                '0082',
                                                                '001',
                                                            ].includes(code),
                                                        ) && (
                                                        <div className="rcp__block">
                                                            <div className="rcp__lf-wrap">
                                                                <div
                                                                    className="rcp__lf"
                                                                    style={{
                                                                        borderColor: '#a80293',
                                                                        color: '#a80293',
                                                                    }}
                                                                >
                                                                    혜택
                                                                </div>
                                                            </div>
                                                            <div className="rcp__rt">
                                                                <ul className="rcp__list">
                                                                    <li className="rcp__item">
                                                                        [덴탈잡 이용권]으로 채용공고를 게재하신 고객님께 DV Point 추가 적립 혜택을 증정 드립니다.
                                                                    </li>
                                                                    {/* <li className="rcp__item">
                                                                        <b>
                                                                            유효기간 :{' '}
                                                                            {formatDate(payment?.couponStartDate)} ~{' '}
                                                                            {formatDate(payment?.couponExpiryDate)}
                                                                        </b>
                                                                    </li>
                                                                    <li className="rcp__item">
                                                                        <b>
                                                                            사용여부 :{' '}
                                                                            {payment?.couponIsUsed === 'Y'
                                                                                ? '사용완료'
                                                                                : new Date(payment?.couponExpiryDate).setHours(0, 0, 0, 0) <
                                                                                    new Date().setHours(0, 0, 0, 0)
                                                                                    ? '기간만료'
                                                                                    : '사용가능(유효기간내에서만 교환신청이 가능하며, 미사용시 소멸됩니다.)'}
                                                                        </b>
                                                                    </li> */}
                                                                    <li className="rcp__item">
                                                                        <p style={{ fontSize: '14px', lineHeight: '1.2', wordBreak: 'keep-all' }}>
                                                                            ※ 이용권 사용일로부터 일주일 이내 DVmall에서 재료 구매 시, 해당 월에 DV Point 10,000P가 추가 적립됩니다.
                                                                        </p>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                        ))}

                                    <button
                                        type="button"
                                        className="rcp__more"
                                        onClick={() => handleShowMore(item.seq)}
                                    >
                                        <span className={`${(item.statusFlag === 'O' ? expandedItems[item.seq] !== false : expandedItems[item.seq] === true) ? 'active' : ''}`}>
                                            결제내역 더보기
                                        </span>
                                    </button>
                                </>
                            )}
                        </div>
                    );
                })
            ) : (
                <p
                    style={{
                        textAlign: 'center',
                        padding: '30px 0px',
                        backgroundColor: '#fff',
                    }}
                >
                    데이터없습니다
                </p>
            )}
        </div>
    );
};

export default RecruitmentStatus;
